import React, { useContext } from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Link,
  Container,
  Stat
} from "@chakra-ui/react"
import Image from "next/image"
import CategoryRank from "../../public/img/experience.png"
import TechStartup from "../../public/img/tech-startup.png"
import TargetedLeads from "../../public/img/seller-leads-customized.png"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ButtonPrimary from "../../components/buttons/PrimaryButton"
import { CheckIcon } from "@chakra-ui/icons"
import NextLink from "next/link"
import { Accordion } from "@chakra-ui/accordion"
import AccordionMenu from "../../components/accordion/AccordionMenu"
import { topSellersByCategoryFaq } from "../../data/TopSellersByCategoryFaq"
import { DomainContext } from "../../components/context/DomainContext"

export default function TopSellersByCategory() {
  const textColor = useColorModeValue("gray.500", "white")
  const domainContextVal = useContext(DomainContext)

  function ButtonClick() {
  }
  return (
    <>
      <Meta
        pageName={"Find Top Amazon Sellers by Category | TrackSellers"}
        description={"Want to sell via third party Amazon sellers? Get top Amazon Sellers list for every category in every Amazon marketplace to market your products."}
        hrefLink={"https://www.tracksellers.com/top-sellers-by-category"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead} >
                Top Amazon Sellers by Category
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} className={styles.ReportTextHeading} mt="1rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
                Uncover the most relevant competition and find potential leads with our unique, category-specific seller rankings
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", sm: "column", md: "column-reverse", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={CategoryRank}
                    alt="CategoryRank"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Unparalleled Category-Specific Amazon Seller Rankings
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Gain insights into top-performing Amazon sellers within specific product categories
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Make data-driven decisions by analyzing the most relevant competition
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Stay ahead of the game with our unique ranking system, not offered by any competitor
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Actionable Amazon Seller Intelligence for Better Business Decisions
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Strategize and optimize your product offerings based on category-specific insights
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Identify opportunities for collaboration or expansion within your target categories
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Boost your Amazon seller performance by learning from the best in your category
                    </Text>
                  </Flex>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={TechStartup}
                    alt="TechStartup"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", sm: "column", md: "column-reverse", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={TargetedLeads}
                    alt="TargetedLeads"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Access Targeted Amazon Seller Leads for Service Providers and Suppliers
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Find potential clients within your specific product category
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Improve lead generation efficiency by focusing on highly relevant leads
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Grow your business by connecting with Amazon sellers in your niche
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
          </Box>

        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Ready to Unlock the Power of Category-Specific Rankings?
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Gain a competitive edge and find potential leads by exploring top Amazon sellers within your target categories.
          </Text>
          <NextLink href={`/sellers/by-category/${domainContextVal.code}`} passHref>
            <Link >
              <ButtonPrimary ButtonClick={ButtonClick} buttonName="Get Started" />
            </Link>
          </NextLink>
        </Box>
        <Box pt="4rem" pb="4rem" pl="15px" pr="15px" background="#fff">
          <Box className={styles.LeadFaqBox}>
            <Heading className={styles.LeadFaqHead}>
              Frequently Asked Questions
            </Heading>
            <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
              {
                topSellersByCategoryFaq?.map((ques, index) => (
                  <AccordionMenu {...ques} key={index} />))
              }
            </Accordion>
          </Box>
        </Box>
      </Box>
    </>
  )
}